import { styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";

const autocompleteInputStyles = ({ borderColor, textColor }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px",
    height: "40px",
    color: textColor,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: borderColor,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${borderColor}`,
    },
  },
  "& .MuiInputBase-input": {
    padding: "10px 14px",
    textOverflow: "clip",
    "&::placeholder": {
      opacity: 1,
    },
  },
  "& .MuiAutocomplete-input": {
    textOverflow: "clip",
    minWidth: "11rem",
  },
  "& .MuiAutocomplete-endAdornment": {
    "& .MuiSvgIcon-root": {
      color: textColor,
    },
  },
});

const autocompleteRootStyles = ({ borderColor }) => ({
  "& .MuiAutocomplete-inputRoot": {
    border: `1px solid ${borderColor}`,
  },
});

const selectStyles = ({ borderColor, textColor }) => ({
  borderRadius: "20px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: borderColor,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${borderColor}`,
  },
  "& .MuiSelect-icon": {
    color: textColor,
  },
  border: `1px solid ${borderColor}`,
  height: "40px",
  color: textColor,
  padding: "10 0px",
});

export const StyledAutocompleteTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "borderColor" && prop !== "textColor",
})(({ borderColor, textColor }) => autocompleteInputStyles({ borderColor, textColor }));

export const StyledAutocomplete = styled(Autocomplete, {
  shouldForwardProp: (prop) => prop !== "borderColor",
})(({ borderColor }) => autocompleteRootStyles({ borderColor }));

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== "borderColor" && prop !== "textColor",
})(({ borderColor, textColor }) => selectStyles({ borderColor, textColor }));
